import React from 'react';
import { NavLink } from 'react-router-dom';
import { ClipboardList, QrCode, User, LayoutDashboard } from 'lucide-react';

export default function MobileBottomNav({ onScanClick }) {
  return (
    <nav className="mobile-nav">
      <NavLink 
        to="/dashboard" 
        className={({ isActive }) => `m-nav-item ${isActive ? 'active' : ''}`}
      >
        <LayoutDashboard size={22} />
        <span>Home</span>
      </NavLink>

      <NavLink 
        to="/technician" 
        className={({ isActive }) => `m-nav-item ${isActive ? 'active' : ''}`}
      >
        <ClipboardList size={22} />
        <span>Jobs</span>
      </NavLink>

      <div className="m-nav-item" onClick={onScanClick}>
        <QrCode size={22} />
        <span>Scan</span>
      </div>

      <NavLink 
        to="/profile" 
        className={({ isActive }) => `m-nav-item ${isActive ? 'active' : ''}`}
      >
        <User size={22} />
        <span>Profile</span>
      </NavLink>
    </nav>
  );
}
